import { OrganisationModel } from "@Shared/Models/OrganisationModel";

export const validateOrgNr = (value: string): boolean => {
	const regex = /\d{6}-\d{4}/
	return regex.test(value)
}

export const validatePhoneNumber = (value: string): boolean => {
	if(value) {
		const regex = /^[\d-]+$/
		return regex.test(value)
	} else {
		return true
	}
}

export const validateFields = (data: OrganisationModel) : {errorField: string, message: string}[] => {
	let results = [] as {errorField: string, message: string}[];
	Object.entries(data)
		.forEach(([key, value]) => {
			switch (key) {
				case 'displayName':
					if (!value){
						results.push({ errorField: key, message: 'Organisationensnamn behöver anges' })
					}
					break;
				case 'addressList':
					if (!value[0]['postalCode']){
						results.push({ errorField: 'postalCode', message: 'Postnummer behöver anges'});
					}
					if (!value[0]['locality']){
						results.push({ errorField: 'locality', message: 'Ort behöver anges' });
					}
					break;
				case 'phoneNumber':
					if (!validatePhoneNumber(value)){
						results.push({ errorField: key, message: 'Felaktigt telefonnummer' });
					}
					break;
				default:
					break;
			}
		});
	return results;
}

export const emailRegex =
	/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

